/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('PromoArchivesCtrl', function($scope, $location, Term, ngNotify) {
    $scope.previous_terms = [];
    const begin_year            = 2015;
    const end_year              = moment().add(4, 'year').format('YYYY');
    $scope.last_year      = { };
    $scope.years_list     = __range__(begin_year, end_year, true);

    $scope.previousTerms = function(year) {
        if ($scope.last_year === year) { return; }
        return Term
        .getPreviousTerms({
            begin:  year,
            end:    year}).$promise
        .then(function(terms) {
            $scope.last_year      = year;
            $scope.previous_terms = terms;
            return $location.search('year', year);}).catch(() => ngNotify.set('Erreur de récupération des murs', 'error'));
    };

    if ($location.search().year != null) {
        return $scope.previousTerms($location.search().year);
    }
});

function __range__(left, right, inclusive) {
  let range = [];
  let ascending = left < right;
  let end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}